<nz-spin [nzSpinning]="loading">
    <div class="container quizzes-container">
        <div class="page-header">
            <div>
                <h2>Quizzes</h2>
                <p class="page-subtitle">Review quizzes and keep details in sync with distributors, companies, and providers.</p>
            </div>
            <button nz-button nzType="primary" (click)="addQuizModal = true">
                <span nz-icon nzType="plus" nzTheme="outline"></span>
                New Quiz
            </button>
        </div>

        <nz-table #basicTable [nzData]="quizzes" [nzFrontPagination]="false" nzBordered>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Distributor</th>
                    <th>Company</th>
                    <th>Provider</th>
                    <th>Created</th>
                    <th>Created By</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let quiz of quizzes">
                    <td>{{ quiz.name }}</td>
                    <td>
                        <span class="status-tag" [ngClass]="quiz.status">{{ quiz.status | titlecase }}</span>
                    </td>
                    <td>{{ quiz.distributor_name }}</td>
                    <td>{{ quiz.company_name }}</td>
                    <td>{{ quiz.provider_name }}</td>
                    <td>{{ quiz.created_at | date: 'mediumDate' }}</td>
                    <td>{{ quiz.created_by_user_first_name | titlecase }} {{ quiz.created_by_user_last_name | titlecase }}</td>
                    <td class="table-actions">
                        <a (click)="openEdit(quiz)">Edit</a>
                        <a (click)="openAssignModal(quiz)">Assign</a>
                        <a (click)="openAssignCompanyModal(quiz)">Assign by Company</a>
                        <a class="danger" (click)="selectedQuiz = quiz; deleteQuizModal = true">Delete</a>
                    </td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</nz-spin>

<nz-modal [(nzVisible)]="addQuizModal" nzTitle="Add Quiz" nzWidth="720px" (nzOnCancel)="addQuizModal = false" (nzOnOk)="addQuiz()">
    <ng-container *nzModalContent>
        <form [formGroup]="addQuizForm" class="modal-form">
            <div class="modal-grid">
                <div class="modal-field">
                    <label class="modal-label">Name</label>
                    <input nz-input formControlName="name" placeholder="Quiz Name" />
                </div>
                <div class="modal-field">
                    <label class="modal-label">Status</label>
                    <nz-select nzShowSearch nzAllowClear formControlName="status" nzPlaceHolder="Select Status">
                        <nz-option *ngFor="let status of statuses" [nzValue]="status" [nzLabel]="status | titlecase"></nz-option>
                    </nz-select>
                </div>
                <div class="modal-field">
                    <label class="modal-label">Distributor</label>
                    <nz-select nzShowSearch nzAllowClear formControlName="distributor_id" nzPlaceHolder="Select Distributor">
                        <nz-option *ngFor="let distributor of distributors" [nzValue]="distributor.id" [nzLabel]="distributor.name"></nz-option>
                    </nz-select>
                </div>
                <div class="modal-field">
                    <label class="modal-label">Company</label>
                    <nz-select nzShowSearch nzAllowClear formControlName="company_id" nzPlaceHolder="Select Company">
                        <nz-option *ngFor="let company of companies" [nzValue]="company.id" [nzLabel]="company.name"></nz-option>
                    </nz-select>
                </div>
                <div class="modal-field">
                    <label class="modal-label">Provider</label>
                    <nz-select nzShowSearch nzAllowClear formControlName="provider_id" nzPlaceHolder="Select Provider">
                        <nz-option *ngFor="let provider of providers" [nzValue]="provider.id" [nzLabel]="provider.name"></nz-option>
                    </nz-select>
                </div>
                <div class="modal-field">
                    <label class="modal-label">Video (optional)</label>
                    <div class="upload-row">
                        <input type="file" accept="video/*" (change)="handleVideoUpload($event, 'add')" [disabled]="videoUploading" />
                        <button nz-button nzType="default" nzSize="small" (click)="clearVideo('add')" type="button" [disabled]="videoUploading || !addQuizForm.get('video_url')?.value">Clear</button>
                    </div>
                    <div class="video-hint" *ngIf="addQuizForm.get('video_url')?.value">
                        Attached: {{ addQuizForm.get('video_url')?.value }}
                    </div>
                </div>
                <div class="modal-field">
                    <label class="modal-label">Percentage Needed to Pass</label>
                    <input nz-input formControlName="percentage_need_to_pass" placeholder="Enter Percentage Needed to Pass" />
                </div>
            </div>

            <div class="modal-field questions-block" formArrayName="questions">
                <div class="questions-header">
                    <div class="modal-label">Questions</div>
                    <button nz-button nzType="default" nzSize="small" type="button" (click)="addQuestion('add')">
                        <span nz-icon nzType="plus" nzTheme="outline"></span>
                        Add Question
                    </button>
                </div>

                <div *ngFor="let question of questionsFormArray.controls; let i = index" [formGroupName]="i" class="question-card">
                    <div class="question-card-header">
                        <div class="modal-label">Question {{ i + 1 }}</div>
                        <button nz-button nzType="text" nzSize="small" class="danger-link" type="button" (click)="removeQuestion(i, 'add')">
                            Remove Question
                        </button>
                    </div>
                    <div class="question-grid">
                        <textarea nz-input formControlName="question" placeholder="Enter Question" [nzAutosize]="{ minRows: 2, maxRows: 5 }"></textarea>
                        <div class="option-row">
                            <input nz-input formControlName="optionInput" placeholder="Type an option and click enter" (keyup.enter)="addOption(i, 'add', $event)" />
                            <button nz-button nzType="default" type="button" (click)="addOption(i, 'add')">Add</button>
                            <button nz-button nzType="link" nzSize="small" type="button" (click)="removeLastOption(i, 'add')">Undo last</button>
                        </div>
                        <div class="option-chips">
                            <nz-tag *ngFor="let optionCtrl of getOptionsArray(i, 'add').controls; let j = index" [nzClosable]="true" (nzOnClose)="removeOption(i, j, 'add')">
                                {{ optionCtrl.value }}
                            </nz-tag>
                        </div>
                        <nz-select nzShowSearch nzAllowClear formControlName="correct_answer" nzPlaceHolder="Select Correct Answer">
                            <nz-option *ngFor="let optionCtrl of getOptionsArray(i, 'add').controls" [nzValue]="optionCtrl.value" [nzLabel]="optionCtrl.value"></nz-option>
                        </nz-select>
                    </div>
                </div>
            </div>
        </form>
    </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="editQuizModal" nzTitle="Edit Quiz" nzWidth="720px" (nzOnCancel)="editQuizModal = false" (nzOnOk)="editQuiz()">
    <ng-container *nzModalContent>
        <form [formGroup]="editQuizForm" class="modal-form">
            <div class="modal-grid">
                <div class="modal-field">
                    <label class="modal-label">Name</label>
                    <input nz-input formControlName="name" placeholder="Quiz Name" [value]="selectedQuiz?.name" />
                </div>
                <div class="modal-field">
                    <label class="modal-label">Status</label>
                    <nz-select nzShowSearch nzAllowClear formControlName="status" nzPlaceHolder="Select Status">
                        <nz-option *ngFor="let status of statuses" [nzValue]="status" [nzLabel]="status | titlecase"></nz-option>
                    </nz-select>
                </div>
                <div class="modal-field">
                    <label class="modal-label">Distributor</label>
                    <nz-select nzShowSearch nzAllowClear formControlName="distributor_id" nzPlaceHolder="Select Distributor">
                        <nz-option *ngFor="let distributor of distributors" [nzValue]="distributor.id" [nzLabel]="distributor.name"></nz-option>
                    </nz-select>
                </div>
                <div class="modal-field">
                    <label class="modal-label">Company</label>
                    <nz-select nzShowSearch nzAllowClear formControlName="company_id" nzPlaceHolder="Select Company">
                        <nz-option *ngFor="let company of companies" [nzValue]="company.id" [nzLabel]="company.name"></nz-option>
                    </nz-select>
                </div>
                <div class="modal-field">
                    <label class="modal-label">Provider</label>
                    <nz-select nzShowSearch nzAllowClear formControlName="provider_id" nzPlaceHolder="Select Provider">
                        <nz-option *ngFor="let provider of providers" [nzValue]="provider.id" [nzLabel]="provider.name"></nz-option>
                    </nz-select>
                </div>
                <div class="modal-field">
                    <label class="modal-label">Video (optional)</label>
                    <div class="upload-row">
                        <input type="file" accept="video/*" (change)="handleVideoUpload($event, 'edit')" [disabled]="videoUploading" />
                        <button nz-button nzType="default" nzSize="small" (click)="clearVideo('edit')" type="button" [disabled]="videoUploading || !editQuizForm.get('video_url')?.value">Clear</button>
                    </div>
                    <div class="video-hint" *ngIf="editQuizForm.get('video_url')?.value">
                        Attached: {{ editQuizForm.get('video_url')?.value }}
                    </div>
                </div>
                <div class="modal-field">
                    <label class="modal-label">Percentage Needed to Pass</label>
                    <input nz-input formControlName="percentage_need_to_pass" placeholder="Enter Percentage Needed to Pass" [value]="selectedQuiz?.percentage_need_to_pass" />
                </div>
            </div>

            <div class="modal-field questions-block" formArrayName="questions">
                <div class="questions-header">
                    <div class="modal-label">Questions</div>
                    <button nz-button nzType="default" nzSize="small" type="button" (click)="addQuestion('edit')">
                        <span nz-icon nzType="plus" nzTheme="outline"></span>
                        Add Question
                    </button>
                </div>

                <div *ngFor="let question of editQuestionsFormArray.controls; let i = index" [formGroupName]="i" class="question-card">
                    <div class="question-card-header">
                        <div class="modal-label">Question {{ i + 1 }}</div>
                        <button nz-button nzType="text" nzSize="small" class="danger-link" type="button" (click)="removeQuestion(i, 'edit')">
                            Remove Question
                        </button>
                    </div>
                    <div class="question-grid">
                        <textarea nz-input formControlName="question" placeholder="Enter Question" [nzAutosize]="{ minRows: 2, maxRows: 5 }"></textarea>
                        <div class="option-row">
                            <input nz-input formControlName="optionInput" placeholder="Type an option (commas allowed) and click Add" (keyup.enter)="addOption(i, 'edit', $event)" />
                            <button nz-button nzType="default" type="button" (click)="addOption(i, 'edit')">Add</button>
                            <button nz-button nzType="link" nzSize="small" type="button" (click)="removeLastOption(i, 'edit')">Undo last</button>
                        </div>
                        <div class="option-chips">
                            <nz-tag *ngFor="let optionCtrl of getOptionsArray(i, 'edit').controls; let j = index" [nzClosable]="true" (nzOnClose)="removeOption(i, j, 'edit')">
                                {{ optionCtrl.value }}
                            </nz-tag>
                        </div>
                        <nz-select nzShowSearch nzAllowClear formControlName="correct_answer" nzPlaceHolder="Select Correct Answer">
                            <nz-option *ngFor="let optionCtrl of getOptionsArray(i, 'edit').controls" [nzValue]="optionCtrl.value" [nzLabel]="optionCtrl.value"></nz-option>
                        </nz-select>
                    </div>
                </div>
            </div>
        </form>
    </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="deleteQuizModal" nzTitle="Delete Quiz" nzOkDanger="true" (nzOnCancel)="deleteQuizModal = false" (nzOnOk)="deleteQuiz(selectedQuiz.id)">
    <ng-container *nzModalContent>
        <p><strong>Are you sure you want to delete this quiz?</strong></p>
        <p class="danger-text">This action cannot be undone.</p>
    </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="assignQuizModal" nzTitle="Assign Quiz" nzWidth="520px" (nzOnCancel)="assignQuizModal = false" (nzOnOk)="assignQuiz()">
    <ng-container *nzModalContent>
        <div *ngIf="selectedQuiz">
            <p><strong>Quiz:</strong> {{ selectedQuiz.name }}</p>
        </div>
        <form [formGroup]="assignQuizForm" class="modal-form">
            <div class="modal-field">
                <label class="modal-label">Select Users</label>
                <nz-select formControlName="users" nzMode="multiple" nzPlaceHolder="Choose users" nzShowSearch [nzLoading]="loadingUsers" nzNotFoundContent="No users found">
                    <nz-option *ngFor="let user of users" [nzLabel]="(user.first_name + ' ' + user.last_name) || user.email || 'Unknown User'" [nzValue]="user.id"></nz-option>
                </nz-select>
            </div>
        </form>
    </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="assignCompanyModal" nzTitle="Assign Quiz by Company" nzWidth="520px" (nzOnCancel)="assignCompanyModal = false" (nzOnOk)="assignQuizToCompany()">
    <ng-container *nzModalContent>
        <div *ngIf="selectedQuiz">
            <p><strong>Quiz:</strong> {{ selectedQuiz.name }}</p>
        </div>
        <form [formGroup]="assignCompanyForm" class="modal-form modal-form-single">
            <div class="modal-field">
                <label class="modal-label">Company</label>
                <nz-select
                  formControlName="company_id"
                  nzPlaceHolder="Select Company"
                  nzShowSearch
                  [nzMode]="canMultiAssignCompanies() ? 'multiple' : null">
                    <nz-option *ngFor="let c of companies" [nzLabel]="c.name" [nzValue]="c.id"></nz-option>
                </nz-select>
            </div>
            <div class="modal-field">
                <label class="modal-label">Provider</label>
                <nz-select formControlName="provider_id" nzPlaceHolder="Select Provider" nzShowSearch>
                    <nz-option nzLabel="Generic" nzValue="generic"></nz-option>
                    <nz-option *ngFor="let provider of providers" [nzLabel]="provider.name" [nzValue]="provider.id"></nz-option>
                </nz-select>
            </div>
            <div class="modal-field">
                <label class="modal-label">Assign Type</label>
                <nz-select formControlName="assign_type" nzPlaceHolder="Select Assign Type">
                    <nz-option nzLabel="Every user in company + new recruits" nzValue="all"></nz-option>
                    <nz-option nzLabel="Every existing user in company (not new)" nzValue="company"></nz-option>
                    <nz-option nzLabel="Only new recruits (no current users)" nzValue="new"></nz-option>
                    <nz-option nzLabel="None" nzValue="none"></nz-option>
                </nz-select>
            </div>
        </form>
    </ng-container>
</nz-modal>
